import http from "@/http-common";

/* eslint-disable */
class SendEmailService {
  sendEmail(data: any): Promise<any> {
    return http.api.post("/signup_sendEmail/", data);
  }

  sendEmailByMenu(data: any): Promise<any> {
    return http.api.post("/signup_sendEmailByMenu/", data);
  }
}

export default new SendEmailService();
